import loggingService from '../util/loggingService'

var serviceName = 'meridianService'
var path = '/Lookup/Meridian/'
var isDebug = false

function listLookup (http) {
    loggingService.log(isDebug, serviceName, 'ListLookup')

    return http.get(path + 'ListLookup')
}

export default {
    listLookup: listLookup
}



// WEBPACK FOOTER //
// ./src/services/lookup/meridianService.js